function addContentInTitle(){
	if(typeof addInTitle !== 'undefined' && addInTitle.length > 0) {
		$('h1.pageTitle').append(' : ');
		for(var i = 0; i < addInTitle.length ; i++){
			$('h1.pageTitle').append(' '+addInTitle[i]);
		}
	}
}